module.exports = __webpack_public_path__ + "img/clients2.f06d5a46.svg";